import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import css from './index.module.css';
import AnimalsList from './animals-list';
import { useService } from '../../../../services/services';
import { useQuery } from '../../../../hooks/use-query';
import Spinner from '../../../../components/common/spinner';
import { SelectedRowsProvider } from '../../../../components/common/table/selected-rows-context';
import Animal from '../../../../interfaces/animal';
import { useHistory } from 'react-router-dom';
interface Props {
  setMissedCountState: Dispatch<SetStateAction<number>>;
}
export default function Animals({ setMissedCountState }: Props) {
  const { t } = useTranslation();
  const { farmId } = useParams<{ farmId: string }>();
  const [params] = useQuery();
  const { animalService } = useService();
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const defaultDate = new Date().toISOString().split('T')[0];

  const date = params?.to || defaultDate;
  setMissedCountState(null);

  useEffect(() => {
    if (!params?.from || !params?.to) {
      const search = new URLSearchParams(history.location.search);
      if (!params?.date) search.set('date', date);
      history.push({ ...history.location, search: search.toString() });
    }
  }, [params, date, history]);

  useEffect(() => {
    setLoading(true);

    const subscription =
      animalService
      .syncAnimals(farmId, { date: params?.date })
      .subscribe(
        () => {
          setLoading(false)
        },
        () => {
          setLoading(false)
        }
      );

    return () => subscription.unsubscribe();
  }, [animalService, farmId, params?.date]);

  if (loading) {
    return (
      <div className={css['loading']}>
        <div>{t('Loading')}</div>
        <Spinner visible={true} size="lg" />
      </div>
    );
  } else {
    return (
      <SelectedRowsProvider<Animal>>
        <AnimalsList />
      </SelectedRowsProvider>
    );
  }
}
